module.exports = __webpack_public_path__ + "img/lijstmaken.f96e6309.png";